import { ChevronLeft } from '@untitledui/icons';

import { IconButton } from '@/lib/base/buttons/button-utility';

import { useSurfaceDismiss } from './surface-dismiss-context';

/**
 * Back chevron for a stacked surface. Reads `back` from the enclosing
 * chrome's `SurfaceDismissContext` and renders nothing when there is nowhere
 * to go, so a header can render it unconditionally in every state and at
 * every depth.
 *
 * Chrome, not content: it knows only that the surface it sits in has a
 * previous entry. Shared by the record slideout's headers (loaded and
 * error/denied) and the CRM create form's header, so a stacked surface never
 * has to invent its own way back.
 */
export function SurfaceBackButton() {
  const surface = useSurfaceDismiss();
  if (!surface?.back) {
    return null;
  }
  return (
    <IconButton
      onClick={surface.back}
      color='tertiary'
      size='xs'
      icon={ChevronLeft}
      aria-label='Go back'
    />
  );
}
